import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FormBuilderState } from './form-builder.reducer';

export const selectFormBuilderState = createFeatureSelector<FormBuilderState>('formBuilder');

export const selectFormConfig = createSelector(
  selectFormBuilderState,
  (state) => state.config
);

export const selectFormValues = createSelector(
  selectFormBuilderState,
  (state) => state.formValues
);

export const selectCurrentSectionId = createSelector(
  selectFormBuilderState,
  (state) => state.currentSectionId
);

export const selectIsLoading = createSelector(
  selectFormBuilderState,
  (state) => state.isLoading
);

export const selectIsSubmitting = createSelector(
  selectFormBuilderState,
  (state) => state.isSubmitting
);

export const selectError = createSelector(
  selectFormBuilderState,
  (state) => state.error
);

export const selectSubmitSuccess = createSelector(
  selectFormBuilderState,
  (state) => state.submitSuccess
);

export const selectSubmitResponse = createSelector(
  selectFormBuilderState,
  (state) => state.submitResponse
);

export const selectCurrentSection = createSelector(
  selectFormConfig,
  selectCurrentSectionId,
  (config, sectionId) => {
    if (!config || !sectionId) return null;
    return config.sections?.find((s) => s.section_id === sectionId) || null;
  }
);

export const selectIsLastSection = createSelector(
  selectFormConfig,
  selectCurrentSectionId,
  (config, sectionId) => {
    if (!config?.sections || !sectionId) return false;
    const sections = config.sections;
    const currentIndex = sections.findIndex((s) => s.section_id === sectionId);
    return currentIndex === sections.length - 1;
  }
);

export const selectUploadedFilesMap = createSelector(
  selectFormBuilderState,
  (state) => state.uploadedFilesMap
);

export const selectIsStatic = createSelector(
  selectFormBuilderState,
  (state) => state.isStatic
);

export const selectStaticConfig = createSelector(
  selectFormBuilderState,
  (state) => state.staticConfig
);

